<template>

    <jet-authentication-card class="min-h-0">

        <h1 class="text-2xl font-bold leading-7 text-gray-900 text-center sm:text-3xl sm:truncate">{{ $t('auth.setPassword')}}</h1>
        <p class="text-center text-gray-500">{{ $t('auth.setPasswordDesc')}}</p>

        <jet-validation-errors class="mb-4 mt-4" />

        <form @submit.prevent="submit">
            <div class="mt-4">
                <jet-label for="password" :value="$t('auth.password')" />
                <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
            </div>

            <div class="mt-4">
                <jet-label for="password_confirmation" :value="$t('auth.passwordRepeat')" />
                <jet-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
            </div>

            <div class="flex items-center justify-end mt-4">
                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    {{ $t('auth.passwordSet') }}
                </primary-button>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from 'vue';
import { Head } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import PrimaryButton from '@/Jetstream/PrimaryButton.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import MainLayout from "@/Layouts/MainLayout";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        PrimaryButton,
        JetInput,
        JetLabel,
        JetValidationErrors
    },
    layout: MainLayout,
    data() {
        return {
            form: this.$inertia.form({
                password: '',
                password_confirmation: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('user.profile.set-password'), {
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'auth.pwUpdated'
                }),
                onFinish: () => this.form.reset('password', 'password_confirmation'),
            })
        }
    }
})
</script>
